import createPersistedState from 'vuex-persistedstate'
import * as types from '../mutation-types/recent-colors'

const namespaced = true
export const namespace = 'RecentColors'

// state
const state = {
    recentColors: {},
}

// mutations
const mutations = {
    [types.SET_RECENT_COLOR](s, {id, color}) {
        s.recentColors = {
            ...s.recentColors,
            [id]: color,
        }
    },
}

const actions = {
    setRecentColor({commit}, payload) {
        commit(types.SET_RECENT_COLOR, payload)
    },
}

// getters
const getters = {
    recentColors: s => {
        return s.recentColors
    },
}

// plugins
const plugins = [
    createPersistedState({
        key: 'recent-colors',
    })
]

export default {namespaced, namespace, state, mutations, actions, getters, plugins}
